import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ConfluenceExtension } from '@atlassian/forge-ui-types';
import { createMakeProductURLPath } from '../createMakeProductURLPath';
import { getModuleByKey, NavigationError, ensurePropertyExists } from './common';
var makeConfluenceURLPath = createMakeProductURLPath('/wiki');
var isCustomContentType = function isCustomContentType(contentType) {
  return contentType.startsWith('forge:');
};
export var confluenceExtensionURLHelpers = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ConfluenceExtension.GLOBAL_PAGE, function (_ref) {
  var properties = _ref.properties,
    environmentId = _ref.environmentId,
    appId = _ref.appId;
  var route = properties.route;
  if (appId && environmentId && route) {
    return makeConfluenceURLPath("/apps/".concat(appId, "/").concat(environmentId, "/").concat(route));
  }
  return null;
}), ConfluenceExtension.GLOBAL_SETTINGS, function (_ref2) {
  var id = _ref2.id;
  return makeConfluenceURLPath('/admin/forge', {
    id: id
  });
}), ConfluenceExtension.SPACE_PAGE, function (_ref3, _ref4) {
  var properties = _ref3.properties,
    environmentId = _ref3.environmentId,
    appId = _ref3.appId;
  var spaceKey = _ref4.spaceKey;
  var route = properties.route;
  if (route && environmentId && appId) {
    return makeConfluenceURLPath("/spaces/".concat(ensurePropertyExists('spaceKey', spaceKey), "/apps/").concat(appId, "/").concat(environmentId, "/").concat(route));
  }
  return null;
}), ConfluenceExtension.SPACE_SETTINGS, function (_ref5, _ref6) {
  var properties = _ref5.properties,
    appId = _ref5.appId,
    environmentId = _ref5.environmentId;
  var spaceKey = _ref6.spaceKey;
  var route = properties.route;
  if (!spaceKey) {
    throw NavigationError.MissingProperty('spaceKey');
  }
  if (route && environmentId && appId) {
    return makeConfluenceURLPath("/spaces/".concat(ensurePropertyExists('spaceKey', spaceKey), "/settings/apps/").concat(appId, "/").concat(environmentId, "/").concat(route));
  }
  return null;
});
export var confluenceNavigationTargetURLHelpers = {
  contentView: function () {
    var _contentView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref7) {
      var contentId, version, resp, _yield$resp$json, id, type, webui;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            contentId = _ref7.contentId, version = _ref7.version;
            if (contentId) {
              _context.next = 3;
              break;
            }
            throw NavigationError.MissingProperty('contentId');
          case 3:
            resp = null;
            _context.prev = 4;
            _context.next = 7;
            return fetch("/wiki/rest/api/content/".concat(contentId));
          case 7:
            resp = _context.sent;
            _context.next = 13;
            break;
          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            throw NavigationError.FailedToFetchContentInfo(contentId);
          case 13:
            _context.next = 15;
            return resp.json();
          case 15:
            _yield$resp$json = _context.sent;
            id = _yield$resp$json.id;
            type = _yield$resp$json.type;
            webui = _yield$resp$json._links.webui;
            if (!(version && version >= 0)) {
              _context.next = 25;
              break;
            }
            if (!isCustomContentType(type)) {
              _context.next = 22;
              break;
            }
            throw new Error('Version is not supported for custom content type');
          case 22:
            return _context.abrupt("return", makeConfluenceURLPath('/pages/viewpage.action', {
              pageId: id,
              pageVersion: "".concat(version)
            }));
          case 25:
            if (!webui) {
              _context.next = 27;
              break;
            }
            return _context.abrupt("return", makeConfluenceURLPath(webui));
          case 27:
            throw NavigationError.LinkForContentNotFound(contentId);
          case 28:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[4, 10]]);
    }));
    function contentView(_x) {
      return _contentView.apply(this, arguments);
    }
    return contentView;
  }(),
  contentEdit: function () {
    var _contentEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref8) {
      var contentId, resp, _yield$resp$json2, edituiv2;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            contentId = _ref8.contentId;
            _context2.prev = 1;
            _context2.next = 4;
            return fetch("/wiki/rest/api/content/".concat(contentId));
          case 4:
            resp = _context2.sent;
            _context2.next = 10;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](1);
            throw NavigationError.FailedToFetchContentInfo(contentId);
          case 10:
            _context2.next = 12;
            return resp.json();
          case 12:
            _yield$resp$json2 = _context2.sent;
            edituiv2 = _yield$resp$json2._links.edituiv2;
            if (!edituiv2) {
              _context2.next = 16;
              break;
            }
            return _context2.abrupt("return", makeConfluenceURLPath(edituiv2));
          case 16:
            throw NavigationError.LinkForContentNotFound(contentId);
          case 17:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[1, 7]]);
    }));
    function contentEdit(_x2) {
      return _contentEdit.apply(this, arguments);
    }
    return contentEdit;
  }(),
  spaceView: function () {
    var _spaceView = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref9) {
      var spaceKey;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            spaceKey = _ref9.spaceKey;
            return _context3.abrupt("return", makeConfluenceURLPath("/spaces/".concat(ensurePropertyExists('spaceKey', spaceKey))));
          case 2:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    function spaceView(_x3) {
      return _spaceView.apply(this, arguments);
    }
    return spaceView;
  }(),
  contentList: function () {
    var _contentList = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(params, _ref10) {
      var getAppForgeUIExtensions, contentType, moduleKey, module, appId, environmentId;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            getAppForgeUIExtensions = _ref10.getAppForgeUIExtensions;
            contentType = params.contentType;
            if (contentType) {
              _context4.next = 4;
              break;
            }
            throw NavigationError.MissingProperty('contentType');
          case 4:
            if (!(contentType === 'customContent' && params.moduleKey)) {
              _context4.next = 16;
              break;
            }
            moduleKey = params.moduleKey;
            _context4.next = 8;
            return getModuleByKey(getAppForgeUIExtensions, moduleKey);
          case 8:
            module = _context4.sent;
            if (module) {
              _context4.next = 11;
              break;
            }
            throw NavigationError.ModuleNotFound(moduleKey);
          case 11:
            appId = module.appId, environmentId = module.environmentId;
            if (!(appId && environmentId)) {
              _context4.next = 14;
              break;
            }
            return _context4.abrupt("return", makeConfluenceURLPath('/search', {
              type: "forge:".concat(appId, ":").concat(environmentId, ":").concat(moduleKey)
            }));
          case 14:
            _context4.next = 22;
            break;
          case 16:
            if (!(contentType === 'page' && params.spaceKey)) {
              _context4.next = 20;
              break;
            }
            return _context4.abrupt("return", makeConfluenceURLPath("/spaces/".concat(params.spaceKey, "/pages")));
          case 20:
            if (!(contentType === 'blogpost' && params.spaceKey)) {
              _context4.next = 22;
              break;
            }
            return _context4.abrupt("return", makeConfluenceURLPath("/spaces/".concat(params.spaceKey, "/blogs")));
          case 22:
            throw NavigationError.InvalidValueForProperty('contentType', contentType);
          case 23:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    }));
    function contentList(_x4, _x5) {
      return _contentList.apply(this, arguments);
    }
    return contentList;
  }()
};